import { motion } from "framer-motion";
import { Logo } from "@/components/Logo";
import { scrollToId } from "@/hooks/useLenis";

const links = [
  { id: "how-it-helps", label: "How it helps" },
];

export const Nav = () => (
  <motion.header
    initial={{ y: -24, opacity: 0 }}
    animate={{ y: 0, opacity: 1 }}
    transition={{ duration: 0.8, delay: 0.2, ease: [0.22, 1, 0.36, 1] }}
    className="fixed inset-x-0 top-3 z-50 px-3 sm:top-5 sm:px-6"
  >
    <nav className="mx-auto flex max-w-6xl items-center justify-between rounded-full border border-[#E4DDD3] bg-[#FAF7F2]/80 py-2 pl-4 pr-2 shadow-[0_8px_30px_-12px_rgba(43,38,35,0.15)] backdrop-blur-xl sm:pl-6">
      <Logo />
      <div className="flex items-center gap-1 sm:gap-2">
        {links.map((l) => (
          <button
            key={l.id}
            data-testid={`nav-${l.id}-link`}
            onClick={() => scrollToId(l.id)}
            className="hidden rounded-full px-4 py-2 text-sm font-medium text-[#464E62] transition-colors hover:bg-[#EFEBE3] hover:text-[#16203A] md:inline-flex"
          >
            {l.label}
          </button>
        ))}
        <button
          data-testid="nav-waitlist-link"
          onClick={() => scrollToId("waitlist")}
          className="rounded-full bg-[#16203A] px-4 py-2.5 text-sm font-semibold text-[#FAF7F2] transition-[background-color,transform] duration-300 hover:-translate-y-0.5 hover:bg-[#1C2B4A] sm:px-5"
        >
          Waitlist
        </button>
      </div>
    </nav>
  </motion.header>
);
